@if(selectedBoardType == boardType.HomePageResourceBoard){
  <div *ngIf="!dynamicHeight" class="h-[50px] bg-[#ffffff] border-b-2 border-[#c1c1c4] shadow-md mb-2 rounded-xl py-1 px-2.5" >
  <div class="lg:flex hidden items-center justify-between mb-5 gap-2.5">
      <!--Left Side -->
      <div class="w-[300px]">
        <div class="flex w-full justify-start items-center gap-2.5">

          <div class="relative w-full">
            <input type="search" [(ngModel)]="searchResourceByName"
              class="w-full font-medium text-xs leading-3 text-[#15191E] ps-9 py-2.5 focus:outline-0 border border-[#E3E6EE] px-3 rounded-md flex gap-2.5 justify-start items-center"
              placeholder="Search Resources..." (input)="onSearchUsers($event)" />
            <img src="../../../../assets/images/icons/tickets/search-black.svg" alt=""
              class="absolute top-[9px] left-3" />
          </div>

        </div>
      </div>
      <!--Right Side -->

      <div class="flex justify-end items-center gap-2.5 font-medium text-xs text-[#15191E] flex-wrap">
        <div class="">
          <!-- you can change w-64 to w-full or custom width -->
          <button class="size-9 focus:outline-0 border border-[#E3E6EE] rounded-md flex items-center justify-center transition cursor-pointer hover:bg-[#F8F8FA]"
            matTooltip="Open Secondary Display" (click)="openSecondaryDisplay()">
            <img src="../../../../../../assets/images/icons/tickets/dual-display-small.svg" alt="table-edit">
          </button>


        </div>
        <!-- Date Range Picker (all other cases) -->
        <div class="relative w-[200px] filter-date"
            >
          <input
          id="entryDate"
            type="text"
            #startPicker="ngModel"
            [(ngModel)]="entryDate"
            ngxDaterangepickerMd
            readonly
            matTooltip="Filter by Ticket Start Date"
            placeholder="Filter by Start Date"
            class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE]
                  rounded-md px-2 py-2.5 pl-9 pr-3 cursor-pointer bg-white w-full
                  bg-no-repeat bg-[length:16px] bg-[position:10px_center]"
            [timePicker]="false"
            [timePickerSeconds]="false"
            [showCancel]="true"
            [timePicker24Hour]="false"
            [showCustomRangeLabel]="true"
            [locale]="dateLocale"
            [alwaysShowCalendars]="true"
            [ranges]="rangesEntry"
            (change)="applyDateRangeFilter()"
          />
        </div>
        <div class="relative w-[200px] filter-date"
            >
          <input
          id="dueDate"
            type="text"
            #duePicker="ngModel"
            [(ngModel)]="dueDate"
            ngxDaterangepickerMd
            readonly
            matTooltip="Filter by Ticket Due Date"
            placeholder="Filter by Due Date"
            class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE]
                  rounded-md px-2 py-2.5 pl-9 pr-3 cursor-pointer bg-white w-full
                  bg-no-repeat bg-[length:16px] bg-[position:10px_center]"
            [timePicker]="false"
            [timePickerSeconds]="false"
            [showCancel]="true"
            [timePicker24Hour]="false"
            [showCustomRangeLabel]="true"
            [locale]="dateLocale"
            [alwaysShowCalendars]="true"
            [ranges]="ranges"
            (change)="applyDateRangeFilter()"
          />
        </div>
        <button
          class="leading-3 border border-[#E3E6EE] rounded-md px-2 py-2 flex gap-2.5 cursor-pointer justify-center items-center"
          (click)="toggleDropdown('ticketFilters', $event)">
          <img src="../../../../assets/images/icons/tickets/filters-black.svg" alt="" />
          <span class="">Filters</span>
          <div class="relative">
            <div class="custom-popup -right-2 top-5 w-screen max-w-[575px] !p-6 text-start cursor-default" [ngClass]="
                isDropdownVisible('ticketFilters')
                  ? 'popup-active'
                  : 'popup-inactive'
              " role="button" tabindex="0" (click)="onDivClick($event); $event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
              <h2 class="text-sm text-[#15191E] font-semibold text-start mb-4">
                Filters
              </h2>

              <div class="grid grid-cols-2 gap-3">
                <div class="col-span-1">
                  <app-select [appendToBody]="false" id="Facility" placeHolder="Facility"
                    [pageResult]="siteService.facility$ | async"
                    (clear)="siteService.fetchSite($event, facilityType,'network-only',null,filters)" (scrollEnd)="
                      siteService.fetchNextSites($event, facilityType)
                    "  
                    (selectionChanged)="onChangeFacility($event)" [clearSelectedValue]="!fcSearch"
                    [(ngModel)]="this.facilitySearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallLocationRefresh"
                    [getAllDatainField]="true">
                  </app-select>

                  <!-- <app-select [appendToBody]="false" id="Facility" placeHolder="Facility"
                    [pageResult]="siteService.facility$ | async"
                    (clear)="siteService.fetchSite($event, facilityType,'network-only',null,filters)" (scrollEnd)="
                      siteService.fetchNextSites($event, facilityType)
                    " (search)="
                      siteService.searchInSites($event, facilityType)
                    " (selectionChanged)="onChangeFacility($event)" [clearSelectedValue]="!fcSearch"
                    [(ngModel)]="this.facilitySearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallLocationRefresh"
                    [getAllDatainField]="true">
                  </app-select> -->
                </div>

                <div class="col-span-1">
                  <app-select-multilevel [closeOnSelect]="true" [appendToBody]="false" placeHolder="Job"
                    bindLabel="name" [groupBy]="'parentName'" [pageResult]="problemListAll"
                    (selectionChanged)="onChangeProblem($event)" [clearSelectedValue]="!ProblemSearch">
                  </app-select-multilevel>
                </div>

                <div class="col-span-1">
                  <app-select id="Location" [appendToBody]="false" placeHolder="Location"
                    [pageResult]="siteService.siteChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, siteType)" (scrollEnd)="
                      siteService.fetchNextSitesByParent(
                        $event,
                        siteType,
                        null,
                        [facilitySearch]
                      )
                    "  
                    (selectionChanged)="onChangeLocation($event)" [clearSelectedValue]="!siteSearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallLocationRefresh">
                  </app-select>


                   <!-- <app-select id="Location" [appendToBody]="false" placeHolder="Location"
                    [pageResult]="siteService.siteChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, siteType)" (scrollEnd)="
                      siteService.fetchNextSitesByParent(
                        $event,
                        siteType,
                        null,
                        [facilitySearch]
                      )
                    " (search)="
                      siteService.searchInSitesByParent(
                        $event,
                        siteType,
                        null,
                        [facilitySearch]
                      )
                    " (selectionChanged)="onChangeLocation($event)" [clearSelectedValue]="!siteSearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallLocationRefresh">
                  </app-select> -->
                </div>

                <div class="col-span-1 text-start">
                  <app-select-multilevel [closeOnSelect]="false" [appendToBody]="false" id="Status" placeHolder="Status"
                    bindLabel="name" [groupBy]="'parentName'" [pageResult]="statusListAll"
                    (selectionChanged)="onChangeStatus($event)" [clearSelectedValue]="!statusSearch" [multiple]="true"
                    [value]="statusIdsList">
                  </app-select-multilevel>
                </div>

                <div class="col-span-1">
                  <app-select [appendToBody]="false" id="Area" placeHolder="Area"
                    [pageResult]="siteService.areaChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, areaType)" (scrollEnd)="
                      siteService.fetchNextSitesByParent(
                        $event,
                        areaType,
                        null,
                        [siteSearch]
                      )
                    "  
                    (selectionChanged)="onChangeArea($event)" [clearSelectedValue]="!areaSearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallAreaRefresh">
                    <!-- Only load data when parent is selected -->>
                  </app-select>

                  <!-- <app-select [appendToBody]="false" id="Area" placeHolder="Area"
                    [pageResult]="siteService.areaChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, areaType)" (scrollEnd)="
                      siteService.fetchNextSitesByParent(
                        $event,
                        areaType,
                        null,
                        [siteSearch]
                      )
                    " (search)="
                      siteService.searchInSitesByParent(
                        $event,
                        areaType,
                        null,
                        [siteSearch]
                      )
                    " (selectionChanged)="onChangeArea($event)" [clearSelectedValue]="!areaSearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallAreaRefresh">
                  </app-select> -->
                </div>

                <div class="col-span-1">
                  <app-select [appendToBody]="false" id="Priority" placeHolder="Priority" class="z-[1000]"
                    [pageResult]="busService.BusLookupPriority$ | async" (clear)="
                      busService.fetchBussinessLookupByCodeActAsParent(
                        $event,
                        this.busLookupCodePriority
                      )
                    " (scrollEnd)="
                      busService.fetchNextBussinessLookupByCodeActAsParent(
                        $event,
                        this.busLookupCodePriority
                      )
                    " (search)="
                      busService.searchInBussinessLookupByCodeActAsParent(
                        $event,
                        this.busLookupCodePriority
                      )
                    " (selectionChanged)="onChangePriority($event)" [clearSelectedValue]="!prioritySearch"
                    [showRefresh]="false">
                    >
                  </app-select>
                </div>
                <div class="col-span-1"> <!-- you can change w-64 to w-full or custom width -->
                  <ng-select
                    class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none w-full"
                    [items]="options" [clearable]="false" bindLabel="name" bindValue="id" [(ngModel)]="selectedOption"
                    (change)="onChangeUser()" placeholder="Select option">
                  </ng-select>
                </div>
              </div>
              <div class="flex justify-end gap-1.5 mt-4">
                <div>
                  <bk-button 
                    variant="secondary"
                    label="Clear"
                    size="sm"
                    [loading]="false" 
                    [disabled]="false"
                    buttonClass="text-[#6B7080] border-[#E3E6EE] bg-white w-full !py-[5px] rounded-md" 
                    (click)="clearFilters()">
                  </bk-button>
                </div>
                <div>
                  <bk-button
                    variant="primary"
                    label="Apply Filters" 
                    size="sm"
                    [loading]="false" 
                    (clicked)="applyFilters()" 
                    [disabled]="false"
                    buttonClass="text-white bg-[#141414] w-full !py-[5px] rounded-md">
                  </bk-button>
                </div>
              </div>
            </div>
          </div>
        </button>

      </div>
    </div>
</div>
}
@else {

  <div *ngIf="selectedBoardType ==boardType.HomePageResourceSecondaryBoard || selectedBoardType == boardType.TicketsResourceSecondaryBoard" class="relative flex justify-center z-[100]">
    <div [matTooltip]="dropdownOpen? 'Show Filters':'Hide Filters'"
      class="size-5 bg-white shadow-md rounded-full flex justify-center items-center cursor-pointer transition-transform duration-300 border border-gray-400"
      (click)="dropdownOpen = !dropdownOpen" [ngClass]="dropdownOpen ? '' : 'rotate-180'">
      <img src="assets/images/icons/arrows/arrow-down-black.svg" class="" height="12" width="12" alt="arrow">
    </div>
  </div>


  <div *ngIf=" selectedBoardType ==boardType.HomePageResourceSecondaryBoard || selectedBoardType ==boardType.TicketsResourceSecondaryBoard"
    class="bg-[#ffffff] border-b-2 border-[#c1c1c4] shadow-md rounded-xl py-1 px-2.5 fixed top-0 w-full z-[99] transition-all duration-500 ease-in-out"
    [ngClass]="dropdownOpen? '' : ''" [style.height]="dropdownOpen ? '0px' : '50px'">





    <div class="lg:flex hidden items-center justify-between mb-5 gap-2.5 transition-opacity duration-400"
      [ngClass]="dropdownOpen ? 'opacity-0 pointer-events-none' : 'opacity-100'">

      <!--Left Side -->
      <div class="w-[300px]">
        <div class="flex w-full justify-start items-center gap-2.5">

          <div class="relative w-full">
            <input type="search" [(ngModel)]="searchResourceByName"
              class="w-full font-medium text-xs leading-3 text-[#15191E] ps-9 py-2.5 focus:outline-0 border border-[#E3E6EE] px-3 rounded-md flex gap-2.5 justify-start items-center"
              placeholder="Search Resources..." (input)="onSearchUsers($event)" />
            <img src="../../../../assets/images/icons/tickets/search-black.svg" alt=""
              class="absolute top-[9px] left-3" />
          </div>

        </div>
      </div>
      <!--Right Side -->
      <div class="flex justify-end items-center gap-2.5 font-medium text-xs text-[#15191E] flex-wrap">

        <!-- Date Range Picker (all other cases) -->
        <div class="relative w-[200px] filter-date"
            >
          <input
          id="entryDate"
            type="text"
            #startPicker="ngModel"
            [(ngModel)]="entryDate"
            ngxDaterangepickerMd
            readonly
            matTooltip="Filter by Ticket Start Date"
            placeholder="Filter by Start Date"
            class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE]
                  rounded-md px-2 py-2.5 pl-9 pr-3 cursor-pointer bg-white w-full
                  bg-no-repeat bg-[length:16px] bg-[position:10px_center]"
            [timePicker]="false"
            [timePickerSeconds]="false"
            [showCancel]="true"
            [timePicker24Hour]="false"
            [showCustomRangeLabel]="true"
            [locale]="dateLocale"
            [alwaysShowCalendars]="true"
            [ranges]="rangesEntry"
            (change)="applyDateRangeFilter()"
          />
        </div>
        <div class="relative w-[200px] filter-date"
            >
          <input
          id="dueDate"
            type="text"
            #duePicker="ngModel"
            [(ngModel)]="dueDate"
            ngxDaterangepickerMd
            readonly
            matTooltip="Filter by Ticket Due Date"
            placeholder="Filter by Due Date"
            class="calendar-input font-medium text-xs text-[#15191E] leading-3 border border-[#E3E6EE]
                  rounded-md px-2 py-2.5 pl-9 pr-3 cursor-pointer bg-white w-full
                  bg-no-repeat bg-[length:16px] bg-[position:10px_center]"
            [timePicker]="false"
            [timePickerSeconds]="false"
            [showCancel]="true"
            [timePicker24Hour]="false"
            [showCustomRangeLabel]="true"
            [locale]="dateLocale"
            [alwaysShowCalendars]="true"
            [ranges]="ranges"
            (change)="applyDateRangeFilter()"
          />
        </div>
        <button
          class="leading-3 border border-[#E3E6EE] rounded-md px-2 py-2 flex gap-2.5 cursor-pointer justify-center items-center"
          (click)="toggleDropdown('ticketFilters', $event)">
          <img src="../../../../assets/images/icons/tickets/filters-black.svg" alt="" />
          <span class="">Filters</span>
          <div class="relative">
            <div class="custom-popup -right-2 top-5 w-screen max-w-[575px] !p-6 text-start cursor-default" [ngClass]="
                  isDropdownVisible('ticketFilters')
                    ? 'popup-active'
                    : 'popup-inactive'
                " role="button" tabindex="0" (click)="onDivClick($event); $event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
              <h2 class="text-sm text-[#15191E] font-semibold text-start mb-4">
                Filters
              </h2>

              <div class="grid grid-cols-2 gap-3">
                <div class="col-span-1">
                  <app-select [appendToBody]="false" id="Facility" placeHolder="Facility"
                    [pageResult]="siteService.facility$ | async"
                    (clear)="siteService.fetchSite($event, selectedSiteType,'network-only',null,filters)" (scrollEnd)="
                        siteService.fetchNextSites($event, selectedSiteType)
                      " (search)="
                        siteService.searchInSites($event, selectedSiteType)
                      " (selectionChanged)="onChangeFacility($event)" [clearSelectedValue]="!fcSearch"
                      [initialSelectedValue]="facilitySearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallLocationRefresh"
                    [getAllDatainField]="true">
                  </app-select>
                </div>

                <div class="col-span-1">
                  <app-select-multilevel [closeOnSelect]="true" [appendToBody]="false" placeHolder="Job" bindLabel="name"
                    [groupBy]="'parentName'" [pageResult]="problemListAll" (selectionChanged)="onChangeProblem($event)"
                    [clearSelectedValue]="!ProblemSearch"
                    [initialSelectedValue]="ProblemSearch">
                  </app-select-multilevel>
                </div>

                <div class="col-span-1">
                  <app-select id="Location" [appendToBody]="false" placeHolder="Location"
                    [pageResult]="siteService.siteChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, siteType)" (scrollEnd)="
                        siteService.fetchNextSitesByParent(
                          $event,
                          siteType,
                          null,
                          [facilitySearch]
                        )
                      " (search)="
                        siteService.searchInSitesByParent(
                          $event,
                          siteType,
                          null,
                          [facilitySearch]
                        )
                      " (selectionChanged)="onChangeLocation($event)" [clearSelectedValue]="!siteSearch"
                      [initialSelectedValue]="siteSearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallLocationRefresh">
                    <!-- Only load data when parent is selected -->
                  </app-select>
                </div>

                <div class="col-span-1 text-start">
                  <app-select-multilevel [closeOnSelect]="false" [appendToBody]="false" id="Status" placeHolder="Status"
                    bindLabel="name" [groupBy]="'parentName'" [pageResult]="statusListAll"
                    (selectionChanged)="onChangeStatus($event)" [clearSelectedValue]="!statusSearch" [multiple]="true"
                    [value]="statusIdsList">
                  </app-select-multilevel>
                </div>

                <div class="col-span-1">
                  <app-select [appendToBody]="false" id="Area" placeHolder="Area"
                    [pageResult]="siteService.areaChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, areaType)" (scrollEnd)="
                        siteService.fetchNextSitesByParent(
                          $event,
                          areaType,
                          null,
                          [siteSearch]
                        )
                      " (search)="
                        siteService.searchInSitesByParent(
                          $event,
                          areaType,
                          null,
                          [siteSearch]
                        )
                      " (selectionChanged)="onChangeArea($event)" [clearSelectedValue]="!areaSearch"
                    [showRefresh]="false" [isClearAble]="true" [isCallPageRefresh]="isCallAreaRefresh"
                    [initialSelectedValue]="areaSearch">
                  </app-select>
                </div>

                <div class="col-span-1">
                  <app-select [appendToBody]="false" id="Priority" placeHolder="Priority" class="z-[1000]"
                    [pageResult]="busService.BusLookupPriority$ | async" (clear)="
                        busService.fetchBussinessLookupByCodeActAsParent(
                          $event,
                          this.busLookupCodePriority
                        )
                      " (scrollEnd)="
                        busService.fetchNextBussinessLookupByCodeActAsParent(
                          $event,
                          this.busLookupCodePriority
                        )
                      " (search)="
                        busService.searchInBussinessLookupByCodeActAsParent(
                          $event,
                          this.busLookupCodePriority
                        )
                      " (selectionChanged)="onChangePriority($event)" [clearSelectedValue]="!prioritySearch"
                      [initialSelectedValue]="prioritySearch"
                    [showRefresh]="false">
                    >
                  </app-select>
                </div>
                <div class="col-span-1"> <!-- you can change w-64 to w-full or custom width -->
                  <ng-select
                    class="border border-[#E3E6EE] rounded shadow-none text-xs leading-6 font-medium text-[#15191E] focus:shadow-none w-full"
                    [items]="options" [clearable]="false" bindLabel="name" bindValue="id" [(ngModel)]="selectedOption"
                    (change)="onChangeUser()" placeholder="Select option">
                  </ng-select>
                </div>
              </div>
              <div class="flex justify-end gap-1.5 mt-4">
                <div>
                  <bk-button 
                    variant="secondary"
                    label="Clear"
                    size="sm"
                    [loading]="false" 
                    [disabled]="false"
                    buttonClass="text-[#6B7080] border-[#E3E6EE] bg-white w-full !py-[5px] rounded-md" 
                    (click)="clearFilters()">
                  </bk-button>
                </div>
                <div>
                  <bk-button 
                    variant="primary"
                    label="Apply Filters"
                    size="sm"
                    [loading]="false" 
                    (clicked)="applyFilters()" 
                    [disabled]="false"
                    buttonClass="text-white bg-[#141414] w-full !py-[5px] rounded-md">
                  </bk-button>
                </div>
              </div>
            </div>
          </div>
        </button>

      </div>
    </div>
  </div>
}


<div
  class="overflow-x-auto overflow-y-hidden bg-[#FBFBFC] border border-[#F1F1F4] rounded-xl py-1 px-2.5 w-full"
  [ngClass]="
    (dynamicHeight
      ? 'h-[calc(100vh-255px)]'
      : selectedBoardType === boardType.HomePageResourceBoard
        ? 'h-[calc(100vh-140px)]'
        : dropdownOpen
          ? 'h-[calc(100vh-30px)]'
          : 'h-[calc(100vh-60px)]'
    )
    + (dropdownOpen ? '' : ' mt-10')
  "
>
  <div class="flex flex-col flex-wrap h-full content-start">
    <!-- Skeleton Loader (when loading) -->
    <ng-container *ngIf="loading">
      <div class="flex flex-col me-2.5 max-w-[240px] min-w-[240px] space-y-2.5" *ngFor="let item of [1,2,3,4,5,6,7,8]">

        <!-- Ticket Cards Skeleton -->
        <div class="bg-white rounded-xl shadow-sm p-3" *ngFor="let t of [1,2,3,4,5,6,7,8]">
          <div class="flex gap-1.5 items-center min-w-0">
            <ngx-skeleton-loader count="1" class="rounded-full"
              [theme]="{ width: '30px', height: '30px', 'border-radius': '50%' }">
            </ngx-skeleton-loader>

            <ngx-skeleton-loader count="1" class="flex-1"
              [theme]="{ width: '100%', height: '16px', 'border-radius': '4px' }">
            </ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader count="1"
            [theme]="{ width: '100%', height: '40px', 'border-radius': '8px', margin: '0px' }">
          </ngx-skeleton-loader>
        </div>

      </div>
    </ng-container>

    <!-- Actual Data (when not loading) -->
    <ng-container *ngIf="!loading && filteredUserTicketsByCount.length > 0">
      <div class="flex flex-col me-3 mb-2.5 max-w-[280px] min-w-[280px]"
        *ngFor="let tickets of filteredUserTicketsByCount">

        <!-- User Header -->
        <div
          class="bg-[#eaeaea] rounded-tr-lg rounded-tl-lg shadow-md divide-y divide-[#E3E6EE] border border-[#E3E6EE] w-full px-1.5 py-1">
          <div class="flex justify-between items-center">
            <div class="flex gap-1.5 items-center min-w-0">
              <app-avatar [userList]="[{ displayName: tickets.userName, pic: tickets.pic }]" [size]="'lg'"
                [showTooltip]="false">
              </app-avatar>
              <span class="font-medium text-sm leading-5 text-[#15191E] truncate">
                {{ tickets.userName }}
              </span>
            </div>

            <!-- Ticket Count -->
            <span [matTooltip]="'Total Tickets'"
              class="text-xs font-semibold text-gray-600 bg-[#f9f9f9] px-2 py-0.5 rounded-full">
              {{ tickets.tickets.length }}
            </span>
          </div>
        </div>

        <!-- Tickets of the User -->
        <div cdkDropList [cdkDropListData]="tickets.tickets" (cdkDropListDropped)="drop($event, tickets)"
          class="flex flex-col {{profileCardHeight}} overflow-y-auto overflow-x-hidden pb-1">

          <div [style.pointer-events]="!TicketResourcesBoardWrite ? 'none' : 'auto'"
            [style.opacity]="!TicketResourcesBoardWrite ? '0.9' : '1'"
            *ngFor="let card of tickets.tickets; let i = index; trackBy: trackByTicketId" cdkDrag [cdkDragData]="card"
            [ngClass]="
                i === 0
                  ? 'bg-white shadow-sm cursor-pointer rounded-br-lg rounded-bl-lg border border-gray-200'
                  : 'bg-white shadow-sm cursor-pointer rounded-lg border border-gray-200'
              " (click)="ticketDetail(card?.id)" (keydown.enter)="ticketDetail(card?.id)" role="button" tabindex="0">

            <div class="flex flex-col h-full justify-between">

              <div class="px-2 py-1">
                <div class="flex justify-between items-start">
                  <!-- Left Content -->
                  <div class="flex-1 min-w-0">
                    <h1 class="text-[#15191E] font-medium text-sm leading-5 break-all line-clamp-1"
                      matTooltip="{{ card?.ticketNoteWithAttachments?.note?.noteText }}">
                      {{ card?.problemLookup?.name  }}
                    </h1>

                  </div>


                  <!-- Priority Flag -->
                  <!-- <ng-container>
                    <svg [matTooltip]="card?.priorityLookup?.name" width="15" height="16" viewBox="0 0 15 16"
                      fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0 ml-[2px]">
                      <path d="M3.21899 1.75V14.25"
                        [attr.stroke]="appUtilService.getTextColor(card?.priorityLookup?.name)" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M3.21899 3H10.219C11.9065 3 12.2815 3.9375 11.094 5.125L10.344 5.875C9.84399 6.375 9.84399 7.1875 10.344 7.625L11.094 8.375C12.2815 9.5625 11.844 10.5 10.219 10.5H3.21899"
                        [attr.stroke]="appUtilService.getTextColor(card?.priorityLookup?.name)" stroke-miterlimit="10"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </ng-container> -->
                  <div class="flex items-center gap-1">

                    <!-- STATUS BADGE -->
                    <div [matTooltip]="getLatestChangeStatus(card)?.statusLookup?.name"
                      class="px-0 rounded-sm whitespace-nowrap">
                      <span
                        class="inline-flex items-center justify-center gap-1 shrink-0 !border-0 px-2 py-[2px] rounded-sm"
                        [ngStyle]="{
                              'background-color': appUtilService.getRandomColor(getLatestChangeStatus(card)?.statusLookup?.name),
                              'border-color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
                            }">
                                            <span class="inline-block rounded-full size-2 border" [ngStyle]="{
                                'border-color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
                              }"></span>

                                            <span class="leading-4 text-[10px]" [ngStyle]="{
                                'color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
                              }">
                          {{
                          getLatestChangeStatus(card)?.statusLookup?.name?.length > 10
                          ? (getLatestChangeStatus(card)?.statusLookup?.name | slice: 0 : 10) + '...'
                          : getLatestChangeStatus(card)?.statusLookup?.name
                          }}
                        </span>
                      </span>
                    </div>

                    <!-- ESTIMATED HOURS (LEFT SIDE AS ORIGINAL) -->


                  </div>


                </div>


                  @if(this.selectedBoardType == this.boardType.TicketsResourceSecondaryBoard){
                    <div class="flex flex-wrap gap-1 w-[270px]">
                      <ng-container *ngFor="let loc of getSortedLocations(ticketLocationsMap[card.id])">
                        <div class="inline-flex items-center flex-wrap border border-gray-300 rounded px-1 py-[1px]" style="font-size: 10px; max-width: 250px;">
                          <span class="font-medium break-all">{{ loc.location.name }}</span>
                          <span *ngIf="loc?.areas?.length" class="mx-1 text-gray-500">|</span>

                          <ng-container *ngFor="let ar of getSortedAreas(loc); let i = index">
                            <span class="break-all">{{ ar.name }}</span>
                            <span *ngIf="i < getSortedAreas(loc).length - 1" class="mx-1 text-gray-400">•</span>
                          </ng-container>
                        </div>
                      </ng-container>

                    </div>

                  }
                  @else{
                  <div class="flex mb-1">
                      <ng-container *ngFor="let loc of ticketLocationsMap[card.id]?.slice(0, 1)">
                        <div class="inline-flex items-center justify-center border border-gray-300 px-1 py-[1px]      h-auto           rounded  " style="font-size: 10px;">
                          <!-- Location name -->
                          <span>{{ loc.location.name }}</span>
                          <span class="bg-[#09090B4D] rounded-full size-1"></span>

                          <!-- Show up to 2 areas -->
                          <span>
                            {{ getFirstTwoAreaNames(loc) }}
                            <ng-container *ngIf="loc?.areas?.length > 1">
                              <span class="inline-flex items-center justify-center border border-gray-300 px-1 py-[1px]      h-auto           rounded  " style="font-size: 10px;"
                                [matTooltip]="getRemainingAreasTooltip(loc)" matTooltipClass="multiline-tooltip"
                                matTooltipPosition="above">
                                +{{ loc.areas.length - 1 }}
                              </span>
                            </ng-container>
                          </span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="getTicketLocationsWithAreas(card).length > 1">
                      <div class="inline-flex items-center justify-center border border-gray-300 px-1 py-[1px]      h-auto           rounded  " style="font-size: 10px;"
                        [matTooltip]="getRemainingLocationsTooltip(card)" matTooltipClass="multiline-tooltip"
                        matTooltipPosition="above">
                        +{{ getTicketLocationsWithAreas(card).length - 1 }}
                      </div>
                    </ng-container>
                  </div>
                  }

                  <!-- Show +N if more locations exist -->



                <div class="flex justify-between items-center text-[8px] flex-wrap">

                  <!-- LEFT SIDE -->
                   <div class="flex items-center gap-1">
                    <div [matTooltip]="'Estimated Hours'" class="px-1 rounded-sm whitespace-nowrap"
                      [ngClass]="getTagStyle(0)">
                      <span class="leading-4 text-[#60646C] text-[10px]">
                        {{ getTotalEstimatedHours(card) }} h
                      </span>
                    </div>
                    <div [matTooltip]="'Regular Hours'" class="px-1 rounded-sm whitespace-nowrap"
                      [ngClass]="getTagStyle(1)">
                      <span class="leading-4 text-[#60646C] text-[10px]">
                        {{ getTotalRegularHours(card) }} h
                      </span>
                    </div>

                    <div [matTooltip]="'Billable Hours'" class="px-1 rounded-sm whitespace-nowrap"
                      [ngClass]="getTagStyle(2)">
                      <span class="leading-4 text-[#60646C] text-[10px]">
                        {{ getTotalBillableHours(card) }} h
                      </span>
                    </div>


                    <!--<div [matTooltip]="getLatestChangeStatus(card)?.statusLookup?.name"
                      class="px-0 rounded-sm whitespace-nowrap">
                      <span
                        class="inline-flex items-center justify-center gap-1 shrink-0 !border-0 px-2 py-[2px] rounded-sm"
                        [ngStyle]="{
                              'background-color': appUtilService.getRandomColor(getLatestChangeStatus(card)?.statusLookup?.name),
                              'border-color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
                            }">
                                            <span class="inline-block rounded-full size-2 border" [ngStyle]="{
                                'border-color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
                              }"></span>

                                            <span class="leading-4 text-[10px]" [ngStyle]="{
                                'color': appUtilService.getTextColor(getLatestChangeStatus(card)?.statusLookup?.name)
                              }">
                          {{
                          getLatestChangeStatus(card)?.statusLookup?.name?.length > 20
                          ? (getLatestChangeStatus(card)?.statusLookup?.name | slice: 0 : 20) + '...'
                          : getLatestChangeStatus(card)?.statusLookup?.name
                          }}
                        </span>
                      </span>
                    </div>-->



                  </div>


                  <!-- RIGHT SIDE → ESTIMATED HOURS + DATE -->
                  <div class="flex items-center gap-2">

                    <!-- COPY Est Hours here (RIGHT SIDE) -->


                    <!-- DATE -->
                    <p class="text-[#6B7080] font-medium text-[10px] leading-4 whitespace-nowrap"
                      [matTooltip]="card?.ticketNo">
                      {{
                      card.dueDate
                      ? (utcToTimeZone.convertUTCToLocalTime(
                      card?.dueDate,
                      card?.facility?.timeZone ? card?.facility?.timeZone : timeZone
                      ) | date : 'MM/dd/yy HH:mm')
                      : 'No due date'
                      }}
                    </p>

                  </div>
                </div>


              </div>


            </div>


          </div>
        </div>


      </div>
    </ng-container>

    <!-- No Records -->
    <div *ngIf="!loading && filteredUserTicketsByCount.length === 0"
      class="absolute inset-0 flex justify-center items-center text-center text-red-500 text-sm font-medium pointer-events-none">
      <p>No Record Found</p>
    </div>

  </div>
</div>
